import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import "react-vertical-timeline-component/style.min.css";

ReactDOM.render(<App />, document.getElementById("root"));
registerServiceWorker();
